<template>
  <div>
    <TwoStepWrapper
      :parentLoading="loading"
      :parentShowLoadingText="true"
      :registered="false"
      :validSendCode="!loading && mobile && !$v.mobile.$error"
      :submitted="submitted"
      :licenceText="licenceText"
      :parentMobile="mobile"
      alertVariant="info"
      :confirmLoadingSpinnerText="$lang.updating_data"
      @setData="changeMobile"
      @updateAccept="updateAccept"
    >
      <template slot="header">
        <div class="d-flex align-items-center fs_16 border-bottom pb-2 mb-3">
          <i class="fas fa-mobile fa-lg mr-2" />
          <b v-text="'تغییر شماره همراه'" />
        </div>
        <div v-if="!loading" class="lh_30 mb-3" v-html="alertText" />
      </template>
      <template slot="body">
        <b-row class="mx-0 border rounded p-3 mb-3 bg-light">
          <b-col cols="12" md="6">
            <b-form-group>
              <requiredComponent
                slot="label"
                :label="`${$lang.mobile}: `"
                :rules="$v.mobile.$params"
              />
              <b-form-input
                type="number"
                autocomplete="off"
                :placeholder="$lang.profileLang.mobile_number_placeholder"
                :state="$v.mobile.$dirty ? !$v.mobile.$error : null"
                v-model="$v.mobile.$model"
              ></b-form-input>
              <b-form-invalid-feedback
                :state="$v.mobile.$dirty ? !$v.mobile.$error : null"
              >
                <div v-if="!$v.mobile.required">
                  {{ $lang.error_required | replace($lang.mobile) }}
                </div>
                <div v-if="!$v.mobile.maxLength">
                  {{ $lang.error_max | replace($lang.mobile, 11) }}
                </div>
                <div v-if="!$v.mobile.minLength">
                  {{ $lang.error_max | replace($lang.mobile, 11) }}
                </div>
                <div v-if="!$v.mobile.numeric">
                  {{ $lang.error_numeric | replace($lang.mobile) }}
                </div>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </template>
    </TwoStepWrapper>
  </div>
</template>
<script>
import TwoStepWrapper from "@/components/base/TwoStepWrapper";
import { pathOr } from "ramda";
import {
  required,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import { isActiveSmsPanel } from "@/shared/utils";

export default {
  components: {
    TwoStepWrapper,
  },
  validations: {
    mobile: {
      required,
      numeric,
      minLength: minLength(11),
      maxLength: maxLength(11),
    },
  },
  data() {
    return {
      accept: false,
      loading: false,
      submitted: false,
      mobile: null,
    };
  },
  computed: {
    alertText() {
      const mobile = pathOr(
        "",
        ["profile", "userInfo", "mobile"],
        this.$store.state
      );
      return `این شماره در ارسال پیامک ورود و تغییر رمز ورود و سایر مکان‌های که نیاز به تایید پیامکی است استفاده می شود.
        <br>
        شماره فعلی ثبت شده شما در سامانه: <b class="text-primary">${mobile}</b>
        <br>
        <i class="fas fa-info-circle fa-lg mr-1 text-danger"></i>
        <span class="text-danger">حتما شماره همراه بنام خودتان باشد تا در ارتباطات بعدی دچار مشکل نشوید.</span>`;
    },
    licenceText() {
      return `با تائید این فرایند شماره همراه شما در این سامانه به ${this.mobile} تغییر خواهد کرد.`;
    },
  },
  created() {
    /* guidance: check active sms and redirect to login when it's false */
    if (!isActiveSmsPanel()) {
      this.$router.push({ name: "Login" });
    }
  },
  methods: {
    ...mapActions("profile", ["getUserInfo"]),
    pathOr,
    isActiveSmsPanel,
    updateAccept(value) {
      this.accept = value;
    },
    async changeMobile(params) {
      try {
        this.loading = true;
        const { two_step_code, control_code } = params;
        const payload = {
          control_code,
          two_step_code,
          mobile: this.mobile,
        };
        const url = this.$config.api_url + this.$config.profile.change_mobile;
        const response = await this.$httpService.patch(url, payload);
        this.submitted = true;
        this.mobile = null;
        this.$v.mobile.$reset();
        await this.getUserInfo();
        this.$notify.success(response.data.message);
        this.$router.push("/");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>